import { useState, useEffect } from 'react'
import userIcon from '../../../assets/images/illustrations/girl-doing-yoga-light.png'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

export default function ChangeProfileAvatar(props) {
    const [newAvatar, setNewAvatar] = useState();
    const [imagePreviewUrl, setImagePreviewURL] = useState();

    function handleImageChange(e) {
        props?.setAvatar(e.target.files[0])
        setImagePreviewURL(URL.createObjectURL(e.target.files[0]))
        console.log(URL.createObjectURL(e.target.files[0]));
    };

    function removeImage(e) {
        props?.setAvatar(null);
        setImagePreviewURL(null)
    }


    return (
        <>
            <div className="col-6 mx-auto mb-3">
                <div className="image w-100 b-radius b-shadow" style={{ backgroundImage: `url(${imagePreviewUrl ? imagePreviewUrl : userIcon})` }} alt="upload an avatar" />
            </div>
            <div className='col-12 text-center'>
                <label htmlFor="upload" className="btn btn-primary" tabIndex="0">
                    <span className="d-none d-sm-block">Upload avatar</span>
                    <InputText type="file" hidden id="upload" accept="image/png, image/jpeg, image/gif" onChange={(e) => (handleImageChange(e), setNewAvatar(e.target.files[0]))} />
                </label>
                {imagePreviewUrl && <Button icon={'pi pi-times'} rounded outlined severity='danger' className='mx-3' onClick={e => removeImage(e)} />}
                <p className="col-12 text-muted mb-0 mt-4 small">Allowed JPG, GIF or PNG. Max size of 2MB</p>
            </div>
        </>
    )
}
